import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get_backlog_table_data_from_redux_with_type } from '../../../redux/po_backlog/backlog.selector';
import { generateNext7Days } from '../../../util';
import { Box, Container, Skeleton } from '@mui/material';
import HistogramChart from '../../../common/components/Chart/HistogramChart';


const TIME_FRAME_DAYS = 7; // Define the time frame for filtering dates

// Helper function to filter data
const filterData = (data, today) => {
  return data.filter(entry => {
    const targetedDate = new Date(entry?.sla_completion_date);
    const timeDifference = targetedDate.getTime() - today.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    // console.log({ targetedDate, today, timeDifference, daysDifference });
    return (daysDifference >= 0.1 && daysDifference <= TIME_FRAME_DAYS);
  });
};

// Helper function to count entries by date
const countByDate = (filteredData) => {
  return filteredData.reduce((acc, entry) => {
    const dateString = entry?.sla_completion_date?.split(" ")[0];
    acc[dateString] = (acc[dateString] || 0) + 1;
    return acc;
  }, {});
};

const getNext7Dates = () => {
  const dates = [];
  for (let i = 1; i <= TIME_FRAME_DAYS; i++) {
    const date = new Date();
    date.setDate(date.getDate() + i);
    dates.push(date.toISOString().split('T')[0]); // Formats the date to "YYYY-MM-DD"
  }
  // console.log({ dates });
  return dates;
};

const ExpiryChartRenderer = ({ sample_type }) => {
  const table_data = useSelector((state) => get_backlog_table_data_from_redux_with_type(state, sample_type));
  const today = new Date();
  const [isLoading, setIsLoading] = useState(true); // Loading state

  const next_7_days = generateNext7Days();

  const [chart_data, set_chart_data] = useState({
    options: { chart: { id: `${sample_type}-bar-chart` }, xaxis: { categories: next_7_days } },
    series: [{ name: `${sample_type} Count`, data: [] }],
  });

  useEffect(() => {
    setIsLoading(true); // Start loading

    const createChartData = (data) => {
      const filteredData = filterData(data, today);
      const updated_count_by_date = countByDate(filteredData);
      const temp_categories = getNext7Dates();
      let categories = next_7_days;
      let zero_count = 0;
      const temp_dataValues = temp_categories.map(category => {
        if (!updated_count_by_date[category]) {
          zero_count++;
        }
        return updated_count_by_date[category] || 0;
      });
      let dataValues = [0, 0, 0, 0, 0, 0, 0];
      if (zero_count < temp_categories.length) {
        dataValues = temp_dataValues;
        categories = temp_categories;
      }

      // console.log({ dataValues });

      return {
        options: {
          chart: { id: "data-bar-chart" },
          xaxis: { categories: categories },
        },
        series: [{ name: "Count", data: dataValues }],
      };
    };

    set_chart_data(createChartData(table_data));

    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table_data]);



  const renderChart = (chart_data, titleSuffix) => (
    <Box className="p-2">
      <HistogramChart
        title={"Target SLA Completion date approaching in next " + TIME_FRAME_DAYS + " days - " + (titleSuffix === "CB" ? "In Process" : titleSuffix === "FP" ? "FP Pack" : titleSuffix)}
        categories={chart_data.options.xaxis.categories}
        series={chart_data.series[0].data}
        no_data_text={"No Upcoming Targets Found"}
        x_axis_title={"Target Dates"}
        y_axis_title={"Targets Each Day"}
        on_click_event={(event, chartContext, config) => { }}
      />
    </Box>
  );

  if (isLoading) {
    return (
      <Container
        style={{
          // height: '300px',
          // display: 'flex',
          // alignItems: 'center',
          // justifyContent: 'center',
        }}
      >
        <Box className="p-2">
          <Skeleton variant="rounded" width={"100%"} height={400} />
        </Box>
        {/* <CircularProgress /> */}
      </Container>
    );
  }

  return (
    <div>
      {
        renderChart(chart_data, sample_type)
      }
    </div>
  );
};

export default ExpiryChartRenderer;